var map = {
	"./dummyImg.png": 37276,
	"./game_character.png": 41855,
	"./history_correct.png": 71454,
	"./history_wrong.png": 92559,
	"./ico_answer.png": 63741,
	"./ico_hint.png": 7688,
	"./quiz_correct.png": 63157,
	"./quiz_wrong.png": 68736,
	"./roulette/rouletteImg.png": 59161,
	"./roulette/roulette_arrow.png": 57160,
	"./roulette/roulette_dummy1.png": 7670,
	"./roulette/roulette_dummy2.png": 98349,
	"./roulette/roulette_dummy3.png": 49815,
	"./roulette_correct.png": 9846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85426;